// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"96caef64","453":"289a3dbd","629":"13c3b7a4"}[chunkId] + ".chunk.js";
};